import React, { useState, useCallback, useMemo } from "react";
import { Button, Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import IntakeAgentForm from "../AgentResponse/IntakeAgentForm";
import styles from "./chatwindow.module.css";

export default function InterviewPackButton(): JSX.Element {
  const [searchParams] = useSearchParams();
  const [showForm, setShowForm] = useState(false);

  // Memoize session ID
  const sessionId = useMemo(
    () => searchParams.get("sessionId"),
    [searchParams],
  );

  // Generate storage key based on session
  const storageKey = useMemo(
    () => `interview_pack_form_shown_${sessionId || "default"}`,
    [sessionId],
  );

  // Check if form was previously shown for this session
  const formPreviouslyShown = useMemo(() => {
    if (typeof window === "undefined") return false;
    return sessionStorage.getItem(storageKey) === "true";
  }, [storageKey]);

  const handleStartInterview = useCallback(() => {
    setShowForm(true);
    // Persist the state to sessionStorage
    if (typeof window !== "undefined") {
      sessionStorage.setItem(storageKey, "true");
    }
  }, [storageKey]);

  // Show form if button was clicked or if it was previously shown in this session
  if (showForm || formPreviouslyShown) {
    return <IntakeAgentForm parsedContent={null} />;
  }

  // Show button initially
  return (
    <Box className={styles.learningPathButtonWrapper}>
      <Button
        variant="contained"
        onClick={handleStartInterview}
        className={styles.learningPathButton}
      >
        Start Interview Pack Generation
      </Button>
    </Box>
  );
}
